import * as React from 'react';

import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
    return (
        <input
            type={type}
            className={cn(
                // DS3 TextInput with an outside label: 44px, 16px padding, a hairline that darkens on
                // hover and goes full contrast on focus.
                'flex h-11 w-full rounded-x30 border border-solid border-stroke-x30 bg-transparent px-4 font-kalshi-sans text-[15px] leading-[22px] text-text-x10 transition-colors placeholder:text-text-x30 hover:border-text-x30 focus:border-stroke-x10 focus:outline-none disabled:cursor-not-allowed disabled:border-transparent disabled:bg-container-x30 disabled:text-text-x20',
                className,
            )}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = 'Input';

export { Input };
